import {
  createBrowserRouter,
  Navigate,
  RouterProvider,
} from 'react-router-dom';

import BlockedPage from './features/auth/components/BlockedPage';
import Login from './features/auth/components/Login';
import RequireAuth from './features/auth/components/RequireAuth';
import Signup from './features/auth/components/Signup';
import Cargo from './features/captains-form/components/cargo/components/Cargo';
import CargoInformation from './features/captains-form/components/cargo/components/CargoInformation';
import CargoTable from './features/captains-form/components/cargo/components/CargoTable';
import Crew from './features/captains-form/components/crew/components/Crew';
import DangerousGoods from './features/captains-form/components/dangerous-goods/components/DangerousGoods';
import GeneralDeclaration from './features/captains-form/components/general-declaration/components/GeneralDeclaration';
import FirstHealthStep from './features/captains-form/components/health/components/FirstHealthStep';
import Health from './features/captains-form/components/health/components/Health';
import SecondHealthStep from './features/captains-form/components/health/components/SecondHealthStep';
import ThirdHealthStep from './features/captains-form/components/health/components/ThirdHealthStep';
import Inspections from './features/captains-form/components/inspections/components/Inspections';
import LocalFormalities from './features/captains-form/components/local-formalities/components/LocalFormalities.js';
import ConfirmWaste from './features/captains-form/components/marpol/components/ConfirmWaste';
import Marpol from './features/captains-form/components/marpol/components/Marpol';
import MarpolTables from './features/captains-form/components/marpol/components/MarpolTables';
import Welcome from './features/captains-form/components/port-call-data/components/Welcome';
import PortCallData from './features/captains-form/components/port-call-data/PortCallData';
import ShipCertificates from './features/captains-form/components/ship-certificates/components/ShipCertificates';
import Solas from './features/captains-form/components/solas/components/Solas';
import SolasPortCalls from './features/captains-form/components/solas/components/SolasPortCalls';
import SolasQuestions from './features/captains-form/components/solas/components/SolasQuestions';
import SolasSecurityMeasures from './features/captains-form/components/solas/components/SolasSecurityMeasures';
import Summary from './features/captains-form/components/summary/components/Summary';
import VesselData from './features/captains-form/components/vessel-data/components/VesselData';
import PortClearanceFormRequest from './features/port-clearance-form-request/components/PortClearanceFormRequest';
import PortClearanceFormRequestSelectedVessel from './features/port-clearance-form-request/components/PortClearanceFormRequestSelectedVessel';
import Passengers from 'features/captains-form/components/passengers/components/Passengers';

import App from './App';

const router = createBrowserRouter([
  {
    path: '/',
    element: (
      <RequireAuth>
        <App />
      </RequireAuth>
    ),
    children: [
      {
        path: 'port-clearance-form-request',
        element: <PortClearanceFormRequest />,
      },
      {
        path: 'port-clearance-form-request/vessel/:mmsi',
        element: <PortClearanceFormRequestSelectedVessel />,
      },
      {
        path: ':uid/welcome',
        element: <Welcome />,
      },
      {
        path: ':uid/port-call-data',
        element: <PortCallData />,
      },
      {
        path: ':uid/vessel-data',
        element: <VesselData />,
      },
      {
        path: ':uid/inspections',
        element: <Inspections />,
      },
      {
        path: ':uid/arrival-crew',
        element: <Crew isArrival={true} />,
      },
      {
        path: ':uid/departure-crew',
        element: <Crew />,
      },
      {
        path: ':uid/arrival-passengers',
        element: <Passengers isArrival={true} />,
      },
      {
        path: ':uid/departure-passengers',
        element: <Passengers />,
      },
      {
        path: ':uid/dangerous-goods',
        element: <DangerousGoods />,
      },
      {
        path: ':uid/cargo',
        element: <Cargo />,
        children: [
          {
            path: 'information',
            element: <CargoInformation />,
          },
          {
            path: 'documents',
            element: <CargoTable />,
          },
        ],
      },
      {
        path: ':uid/solas-and-isps-code',
        element: <Solas />,
        children: [
          {
            path: 'questions',
            element: <SolasQuestions />,
          },
          {
            path: 'port-calls',
            element: <SolasPortCalls />,
          },
          {
            path: 'security-measures',
            element: <SolasSecurityMeasures />,
          },
        ],
      },
      {
        path: ':uid/local-formalities',
        element: <LocalFormalities />,
      },
      {
        path: ':uid/marpol',
        element: <Marpol />,
        children: [
          {
            path: 'confirm-waste',
            element: <ConfirmWaste />,
          },
          {
            path: 'tables',
            element: <MarpolTables />,
          },
        ],
      },
      {
        path: ':uid/health',
        element: <Health />,
        children: [
          {
            path: 'first-step',
            element: <FirstHealthStep />,
          },
          {
            path: 'second-step',
            element: <SecondHealthStep />,
          },
          {
            path: 'third-step',
            element: <ThirdHealthStep />,
          },
        ],
      },
      {
        path: ':uid/ship-certificates',
        element: <ShipCertificates />,
      },
      {
        path: ':uid/general-declaration',
        element: <GeneralDeclaration />,
      },
      {
        path: ':uid/summary',
        element: <Summary />,
      },
      {
        path: '*',
        element: <Navigate to="/" replace />,
      },
    ],
  },
  {
    path: '/signup',
    element: <Signup />,
  },
  {
    path: '/login',
    element: <Login />,
  },
  {
    path: '/blocked',
    element: <BlockedPage />,
  },
]);

const Routes = () => <RouterProvider router={router} />;
export default Routes;
